import * as snippetTypes from './snippetTypes';

const initialState = {
    data: null,
    loading: true,
};

const snippetReducer = (state = initialState, action) => {
    switch (action.type) {
        case snippetTypes.GET_SNIPPETS_SUCCESS:
            return {
                ...state,
                data: action.payload,
            };
        case snippetTypes.SET_SNIPPETS_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        default:
            return state;
    }
};

export default snippetReducer;
